import type { ConnectorDefinition } from "./types";

export function isConnectorAvailable(
  definition: ConnectorDefinition,
  oauthClientIdentifiers: ReadonlySet<string>
) {
  if (definition.oauth?.clientCredentialsFrom === "env") {
    return oauthClientIdentifiers.size > 0;
  }
  if (definition.oauth?.clientCredentialsFrom === "managed") {
    return oauthClientIdentifiers.has(definition.identifier);
  }
  return true;
}
